import React from "react";
import "./Settings.scss";
import {MDBBox, MDBContainer, MDBListGroup, MDBListGroupItem, MDBTypography} from "mdbreact";
import BottomNav from "../../component/BottomNav/BottomNav";
import TopNavSubpage from "../../component/TopNav/TopNavSubpage";
import {Fade} from "react-reveal";
import {assetUrl} from "../../serviceApi";

const BellIcon = assetUrl+"images/setting-notification.png";
const WidgetIcon = assetUrl+"images/setting-widget.png";
const LanguagePrefIcon = assetUrl+"images/setting-language.png";
const AngleRight = assetUrl+"images/arrow-right-s-line.png";

class Settings extends React.Component {
	state = {
		recive_notification: true,
		update_mail: false,
		add_widget_to_home: false
	}
	handleSwitchChange = (e, feild) => {
		this.setState({
			[feild]: e.target.checked
		});
	}

	render() {
		return (
			<div>
				<TopNavSubpage heading={"Settings"} wallet={false} notify={false}/>
				<MDBContainer className="settings-component px-4 pb-4">
					<MDBListGroup style={{width: "100%"}}>
						<Fade bottom cascade>
							<MDBListGroupItem className="px-0 py-4">
								<ListItemContent
									icon={BellIcon}
									title={"Receive Notifications"}
									handleSwitchChange={this.handleSwitchChange}
									toggle={this.state.recive_notification}
									feild={"recive_notification"}
									is_toggle={true}
								/>
							</MDBListGroupItem>
							{/*<MDBListGroupItem className="px-0 py-4">*/}
							{/*	<ListItemContent*/}
							{/*		icon={MailIcon}*/}
							{/*		title={"Send Updates to Email"}*/}
							{/*		handleSwitchChange={this.handleSwitchChange}*/}
							{/*		toggle={this.state.update_mail}*/}
							{/*		feild={"update_mail"}*/}
							{/*		is_toggle={true}*/}
							{/*	/>*/}
							{/*</MDBListGroupItem>*/}
							<MDBListGroupItem className="px-0 py-4">
								<ListItemContent
									icon={WidgetIcon}
									title={"Add Widget to Home Screen"}
									handleSwitchChange={this.handleSwitchChange}
									toggle={this.state.add_widget_to_home}
									feild={"add_widget_to_home"}
									is_toggle={true}
								/>
							</MDBListGroupItem>
							<MDBListGroupItem className="px-0 py-4">
								<ListItemContent
									icon={LanguagePrefIcon}
									title={"Language Preference"}
									is_toggle={false}
								/>
							</MDBListGroupItem>
						</Fade>
					</MDBListGroup>

					{/*<MDBBox className="bottom-navbar">*/}
					{/*	<BottomNav/>*/}
					{/*</MDBBox>*/}
				</MDBContainer>
			</div>

		);
	}
}

export default Settings;

class ListItemContent extends React.Component {
	render() {
		return (
			<MDBBox className="d-flex justify-content-between align-items-center list-item-section">
				<MDBBox className="d-flex align-items-center">
					<MDBBox className="mr-3 icon-section">
						<img src={this.props.icon} alt="icon" style={{width:"24px",objectFit:"contain"}}/>
					</MDBBox>
					<MDBTypography tag="p" className="m-0 title">{this.props.title}</MDBTypography>
				</MDBBox>
				{/*<TopNavSubpage heading={this.props.title} wallet={false} notify={false}/>*/}
				<MDBBox>
					{
						this.props.is_toggle === true ?
							<div className="checkbox switcher">
								<label htmlFor={this.props.feild} className="mb-0">
									<input type="checkbox" id={this.props.feild} value={this.props.toggle}
									       checked={this.props.toggle}
									       onChange={(e) => this.props.handleSwitchChange(e, this.props.feild)}
									/>
									<span><small></small></span>
								</label>
							</div> :
							<div className="d-flex align-items-center">
								<MDBTypography tag="p" className="mb-0  language-title">ENG</MDBTypography>
								<img src={AngleRight} alt="AngleRight" className="img-fluid"/>
							</div>
					}
				</MDBBox>
			</MDBBox>
		);
	}
}
